import { apiFetch } from "./client";

export const paymentApi = {
  getPaymentMethods: (type = "") => {
    const query = type ? `?type=${encodeURIComponent(type)}` : "";
    return apiFetch(`/payments/methods${query}`);
  },
  createPaymentMethod: (payload) =>
    apiFetch("/payments/methods", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updatePaymentMethod: (methodId, payload) =>
    apiFetch(`/payments/methods/${methodId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  deletePaymentMethod: (methodId) =>
    apiFetch(`/payments/methods/${methodId}`, {
      method: "DELETE",
    }),
  makePayment: (payload) =>
    apiFetch("/payments", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  getPayments: () => apiFetch("/payments"),
};
